import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import SimpleModal from './SimpleModal';

const TITLE = 'Alerts';
const MODEL_TYPE = 'alert';
const DEFAULT_URL = '/alerts/';
const BASE_URL = `${DEFAULT_URL}edit/`;

const AlertModal = ({
  params = [],
  newAlert = noop,
  ...props
}) => {
  const modelId = params[0] === 'alerts' && params[2] !== 'new' && params[2];
  const getCollection = () => Account.get('alerts');
  return (<SimpleModal
    title={TITLE}
    modelType={MODEL_TYPE}
    defaultUrl={DEFAULT_URL}
    baseUrl={BASE_URL}
    modelId={modelId}
    getCollection={getCollection}
    newItem={newAlert}
    {...props}
  />);
};

AlertModal.propTypes = {
  params: PropTypes.array,
  newAlert: PropTypes.func,
};

export default AlertModal;
